import styles from "./Spinner.module.css";

export const Spinner = ({ size = 28 }: { size?: number }) => (
  <span className={styles.spinner} style={{ width: size, height: size }} role="status" aria-label="Loading" />
);

export const PageSpinner = () => (
  <div className={styles.page}>
    <Spinner size={32} />
  </div>
);
